module.exports = __webpack_public_path__ + "img/30.9655bf03.png";